
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/timeline",
      function () {
        return require("private-next-pages/[slug]/timeline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/timeline"])
      });
    }
  